import { SVGAttributes } from 'react';

export const SocketIcon = ({ className, id, ...rootProps }: SVGAttributes<SVGSVGElement>) => (
    <svg viewBox="0 0 502 258" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={id} className={className}>
        <g clipPath="url(#clip0_8345_16862)">
            <path
                d="M309.395 112.404C309.395 112.404 435.208 47.4065 410.88 122.787C386.552 198.167 499.523 141.4 499.523 141.4"
                stroke="var(--icon-socket-wire-color)"
                strokeWidth="4"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M249.493 152.446C249.014 151.208 249.627 149.815 250.861 149.336L267.739 143.007L269.47 147.49L252.592 153.819C251.358 154.298 249.971 153.684 249.493 152.446Z"
                fill="var(--icon-socket-wire-color)"
                stroke="var(--icon-socket-wire-color)"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M258.004 117.821L241.125 124.15C239.892 124.63 238.504 124.015 238.026 122.777C237.548 121.539 238.16 120.146 239.394 119.667L256.272 113.338L258.004 117.821Z"
                fill="var(--icon-socket-wire-color)"
                stroke="var(--icon-socket-wire-color)"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M260.659 108.862C259.898 106.892 257.69 105.914 255.727 106.678L253.986 107.354L275.852 163.976L277.593 163.299C279.556 162.536 280.53 160.32 279.77 158.35"
                fill="var(--icon-socket-main-shadow)"
            />
            <path
                d="M279.642 158.586L299.252 151.248C305.005 149.011 307.861 142.518 305.632 136.746C304.971 135.035 305.563 133.093 307.063 132.046L314.525 126.839C316.431 125.509 317.182 123.042 316.343 120.869L312.851 111.825C312.012 109.652 309.8 108.338 307.498 108.644L298.489 109.842C296.677 110.083 294.935 109.048 294.275 107.338C292.046 101.565 285.576 98.6992 279.823 100.936L260.213 108.274L279.642 158.586Z"
                fill="var(--icon-socket-main-shadow)"
            />
            <path
                d="M257.043 99.5037C256.283 97.5337 254.075 96.5556 252.112 97.3191L250.371 97.9959L272.237 154.617L273.977 153.941C275.94 153.177 276.915 150.961 276.154 148.992"
                fill="var(--icon-socket-main)"
            />
            <path
                d="M276.027 149.227L295.637 141.889C301.389 139.652 304.246 133.16 302.016 127.387C301.356 125.677 301.947 123.735 303.448 122.688L310.909 117.481C312.816 116.15 313.567 113.683 312.728 111.511L309.236 102.467C308.397 100.294 306.185 98.9794 303.883 99.2856L294.873 100.483C293.061 100.724 291.32 99.6897 290.66 97.9792C288.431 92.2069 281.96 89.3408 276.208 91.5778L256.598 98.9159L276.027 149.227Z"
                fill="var(--icon-socket-main)"
            />
            <path
                d="M271.751 121.907L290.093 122.43C291.156 122.46 291.782 121.244 291.144 120.391L288.906 117.402C288.356 116.668 288.737 115.61 289.627 115.398L294.846 114.155C296.285 113.812 296.075 111.695 294.597 111.643L278.709 111.083C277.662 111.046 277.023 112.226 277.625 113.087L279.432 115.673C279.945 116.408 279.561 117.43 278.692 117.642L271.488 119.396C270.049 119.747 270.271 121.865 271.751 121.907Z"
                fill="var(--icon-socket-center)"
            />
            <path
                d="M176.584 159.033C176.584 159.033 44.9598 215.365 79.6096 162.174C114.259 108.984 57.7251 97.5271 34.825 101.719C11.925 105.91 2.90625 110.959 2.90625 110.959"
                stroke="var(--icon-socket-wire-color)"
                strokeWidth="4"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M217.094 122.593C216.485 120.994 214.704 120.188 213.107 120.789L194.073 127.954C187.901 130.319 184.809 137.257 187.166 143.451C187.864 145.286 187.22 147.362 185.608 148.476L177.59 154.013C175.542 155.428 174.724 158.066 175.611 160.397L179.304 170.101C180.191 172.432 182.553 173.852 185.02 173.536L194.674 172.301C196.616 172.052 198.476 173.169 199.174 175.005C201.531 181.198 208.445 184.302 214.617 181.936L233.616 174.784C235.227 174.178 236.038 172.372 235.424 170.76L217.094 122.593Z"
                fill="var(--icon-socket-main-shadow)"
            />
            <path
                d="M213.83 113.547C213.222 111.948 211.44 111.142 209.843 111.743L190.81 118.908C184.638 121.273 181.545 128.211 183.902 134.405C184.6 136.24 183.957 138.317 182.344 139.43L174.326 144.967C172.278 146.382 171.46 149.02 172.347 151.351L176.04 161.055C176.927 163.386 179.289 164.806 181.756 164.49L191.411 163.255C193.353 163.006 195.212 164.124 195.91 165.959C198.267 172.152 205.181 175.256 211.353 172.89L230.352 165.739C231.963 165.132 232.774 163.326 232.161 161.714L213.83 113.547Z"
                fill="var(--icon-socket-main)"
            />
            <path
                d="M207.645 130.34L215.854 152.924"
                stroke="var(--icon-socket-center)"
                strokeWidth="4"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M196.617 137.999L201.474 151.36"
                stroke="var(--icon-socket-center)"
                strokeWidth="4"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M210.096 96.0401C210.448 96.3244 210.909 96.3811 211.302 96.2287C211.495 96.154 211.671 96.0287 211.81 95.8556C212.233 95.3295 212.151 94.5596 211.626 94.1355L201.82 86.2015C201.296 85.7777 200.529 85.8603 200.106 86.3859C199.683 86.912 199.766 87.6819 200.29 88.1059L210.096 96.0401Z"
                fill="var(--icon-socket-splash)"
            />
            <path
                d="M238.816 85.3871C239.035 85.4214 239.25 85.3949 239.443 85.3202C239.836 85.1678 240.139 84.815 240.209 84.3674L242.153 71.8782C242.257 71.2105 241.802 70.5852 241.137 70.4807C240.471 70.3763 239.848 70.8333 239.744 71.5004L237.8 83.9894C237.696 84.6573 238.151 85.2828 238.816 85.3871Z"
                fill="var(--icon-socket-splash)"
            />
            <path
                d="M224.638 88.9004C225.266 88.6569 225.578 87.9488 225.335 87.3187L216.257 63.7359C216.014 63.1058 215.309 62.7922 214.68 63.0356C214.053 63.2791 213.74 63.9875 213.983 64.6177L223.061 88.2005C223.304 88.8305 224.01 89.1439 224.638 88.9004Z"
                fill="var(--icon-socket-splash)"
            />
            <path
                d="M275.617 176.783C275.268 176.496 274.807 176.436 274.413 176.585C274.22 176.658 274.042 176.781 273.902 176.953C273.474 177.476 273.55 178.246 274.071 178.675L283.81 186.692C284.331 187.12 285.099 187.044 285.526 186.522C285.953 185.999 285.877 185.229 285.357 184.8L275.617 176.783Z"
                fill="var(--icon-socket-splash)"
            />
            <path
                d="M246.81 187.193C246.591 187.157 246.377 187.182 246.183 187.255C245.789 187.404 245.483 187.754 245.409 188.201L243.36 200.673C243.25 201.34 243.7 201.969 244.365 202.079C245.029 202.19 245.656 201.738 245.765 201.072L247.814 188.599C247.924 187.932 247.474 187.303 246.81 187.193Z"
                fill="var(--icon-socket-splash)"
            />
            <path
                d="M261.018 183.8C260.388 184.038 260.07 184.743 260.307 185.375L269.187 209.034C269.425 209.666 270.128 209.986 270.758 209.748C271.388 209.509 271.706 208.804 271.469 208.172L262.589 184.513C262.351 183.881 261.648 183.561 261.018 183.8Z"
                fill="var(--icon-socket-splash)"
            />
        </g>
    </svg>
);

SocketIcon.displayName = 'SocketIcon';
